import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { Sparte, TextNodeType } from '@mwe/models';
import { CategoryIconSrcPipe, TranslateCategoryPipe } from '@mwe/ui/pipes';

/** @deprecated
 * replace with mwe-product-icons
 * */
@Component({
  selector: 'mwe-product-icon',
  templateUrl: './product-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateCategoryPipe, CategoryIconSrcPipe],
})
export class ProductIconComponent {
  category = input<Sparte | string>();
  size = input<'sm' | 'md' | 'lg'>();
  showText = input<boolean>(true);
  textNodeType = input<TextNodeType>('h6');
  maxWidth = computed(() => {
    switch (this.size()) {
      case 'sm':
        return '32px';
      case 'md':
        return '50px';
      case 'lg':
        return '76px';
      default:
        return '';
    }
  });
  fontSize = computed(() => {
    switch (this.size()) {
      case 'sm':
        return '12px';
      case 'md':
        return '18px';
      default:
        return '';
    }
  });
  heading = signal<string>(undefined);
}
